import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { NoDataAvailableComponent } from '@app/shared/components/no-data-available/no-data-available.component';
import { AddRelatedCourseComponent } from '../add-related-course/add-related-course.component';
import { RelatedCourseListingComponent } from '../related-course-listing/related-course-listing.component';
import { FormGroup } from '@angular/forms';
import { CourseService } from '../../services/course.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HomeService } from '@app/pages/home/services/home.service';
import { SuccessOrWarningPopupComponent } from '@app/shared/components/success-or-warning-popup/success-or-warning-popup.component';
import { CourseCommonFunctions } from '../../course-util/course-common-functions';

@Component({
    selector: 'app-manage-related-courses',
    imports: [SharedModule, NoDataAvailableComponent, AddRelatedCourseComponent, RelatedCourseListingComponent, SuccessOrWarningPopupComponent],
    templateUrl: './manage-related-courses.component.html',
    styleUrl: './manage-related-courses.component.css',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ManageRelatedCoursesComponent implements OnInit {
  relatedCourseMatData = inject(MAT_DIALOG_DATA);
  courseService = inject(CourseService);
  homeApiService = inject(HomeService);
  courseCommonFn = inject(CourseCommonFunctions);
  relatedCourseForm!: FormGroup;
  showPages: string[] = ['add', 'edit', 'view'];
  pageType = signal<string>('');
  noDataPageName: string = '';
  loadPageData = signal<boolean>(false);
  relatedCourseId: any = null;
  relatedCourseRefData = signal<any>({});
  relatedCourseAjaxData = signal<any>({});
  relatedCourseData = signal<any>(null);
  totalRelatedCourseCount = signal<number>(0);
  relatedCourseListSize: number = 100;
  currentPageNo: number = 1;
  relatedCourseJSONDetails = signal<any>(null);
  buttonType: string = '';
  successOrWarnPopupType = signal<string>('');
  successOrWarnMsg = signal<string>('');

  ngOnInit(): void {
    this.noDataPageName = this.relatedCourseMatData?.pageName?.replace('-course', '') + '_related_course';
    this.getRelatedCourseList();
  }

  getRelatedCourseList() {
    this.courseService.getRelatedCourseList(this.relatedCourseMatData.institutionId, this.relatedCourseMatData.courseId, this.relatedCourseMatData.courseInstanceId, this.currentPageNo, this.relatedCourseListSize).subscribe({
      next: (res: any) => {
        this.loadPageData.set(true);
        this.relatedCourseData.set(res?.courseInstances || null);
        this.totalRelatedCourseCount.set(res?.totalRecordCount || 0);
        this.courseCommonFn.relatedCourseCount.set(this.totalRelatedCourseCount());
      }
    })
  }

  openAddRelatedCourse(pageData: any) {
    this.relatedCourseId = pageData?.relatedCourseId || null;
    this.pageType.set(this.relatedCourseMatData?.pageName?.includes('view') ? 'view' : pageData?.pageType);
    this.getInstitutionDetails();
    this.getRelatedCourseRefData();
    if (!this.relatedCourseJSONDetails())
      this.courseService.getRelatedCourseJSONDetails().subscribe({
        next: (data: any) => {
          this.relatedCourseJSONDetails.set(data);
        }
      })
  }

  getRelatedCourseRefData() {
    if (!Object.keys(this.relatedCourseRefData()).length)
      this.courseService.getRelatedCourseRefData().subscribe({
        next: (refData: any) => {
          const refDataMap: any = {};
          refData?.referenceTypes?.forEach((data: any) => {
            let fieldName = data?.name.toLowerCase() + 'id';
            if (!fieldName?.includes('pathway'))
              fieldName = 'pathway' + fieldName;
            const countryData = JSON.parse(localStorage.getItem("countryDetails") ?? '');
            const refValue = this.courseCommonFn.getFilteredValues(data?.values, countryData, this.relatedCourseMatData.courseTypeId, 'course');
            refDataMap[fieldName] = refValue;
          })
          this.relatedCourseRefData.set(refDataMap);
        }
      })
  }

  getInstitutionDetails() {
    this.homeApiService.getInstitutionDetails(this.relatedCourseMatData.countryId).subscribe({
      next: (data: any) => {
        if (data?.institutions) {
          const ajaxData = { ...this.relatedCourseAjaxData() };
          ajaxData['pathwayInstitutionId'] = data.institutions?.map((ins: any) => {
            return { id: ins.institutionId, name: ins.institutionName }
          });
          this.relatedCourseAjaxData.set(ajaxData);
        }
      }
    });
  }

  goToListingPage() {
    this.buttonType = '';
    this.pageType.set('');
    this.relatedCourseId = null;
  }

  getButtonType(buttonType: string) {
    this.buttonType = buttonType;
  }

  loadRelatedCourseData(message: any) {
    if (message?.success) {
      this.relatedCourseData.set(null);
      this.goToListingPage();
      this.getRelatedCourseList();
    }
    if (message && message !== 'reset') {
      const msgType = (message?.success) ? 'success' : 'warning';
      this.getMessage(message[msgType], msgType);
    } else {
      this.getMessage();
      if (message === 'reset')
        this.getButtonType('');
    }
  }

  getMessage(message?: string, popType?: string) {
    this.successOrWarnPopupType.set(popType ?? '');
    this.successOrWarnMsg.set(message ?? '');
    if (message)
      setTimeout(() => {
        this.getMessage();
      }, 5000);
  }
}